import { render } from "./FormModalLayout.vue?vue&type=template&id=45803cd9&scoped=true&ts=true&lang=pug"
import script from "./FormModalLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormModalLayout.vue?vue&type=script&lang=ts&setup=true"

import "./FormModalLayout.vue?vue&type=style&index=0&id=45803cd9&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45803cd9"]])

export default __exports__